import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import Select from 'react-select'
import { defineMessages, injectIntl } from "react-intl";
import { DOC_TEMPLATE, EMAIL_TEMPLATE } from '../../state/template/TemplateType';

const messages = defineMessages({
    "template_placeholder": {
        id: 'templates.selector.template_placeholder',
        defaultMessage: 'Select a proposal template...',
    },
    "invoice_template_placeholder": {
        id: 'templates.selector.invoice_template_placeholder',
        defaultMessage: 'Select an invoice template...',
    },
    "order_template_placeholder": {
        id: 'templates.selector.order_template_placeholder',
        defaultMessage: 'Select an order template...',
    },
    "contract_template_placeholder": {
        id: 'templates.selector.contract_template_placeholder',
        defaultMessage: 'Select a contract template...',
    },
    "invoice_email_template_placeholder": {
        id: 'templates.selector.invoice_email_template_placeholder',
        defaultMessage: 'Select a invoice email template...',
    },
    "quote_email_template_placeholder": {
        id: 'templates.selector.quote_email_template_placeholder',
        defaultMessage: 'Select a quote email template...',
    },
    "order_email_template_placeholder": {
        id: 'templates.selector.order_email_template_placeholder',
        defaultMessage: 'Select a order email template...',
    },
    "contract_email_template_placeholder": {
        id: 'templates.selector.contract_email_template_placeholder',
        defaultMessage: 'Select a contract email template...',
    },
    "snippet_placeholder": {
        id: 'templates.selector.snippet_placeholder',
        defaultMessage: 'Select a snippet...',
    },
    "no_snippet_available": {
        id: 'templates.selector.no_snippet_available',
        defaultMessage: 'No snippet available',
    },
    "default_name": {
        id: 'templates.default_template_name',
        defaultMessage: 'Default template',
    },
})

class TemplateSelector extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: [],
            selectedOption: this.props.value || '',
            documentType: this.props.documentType || '',
            placeholder: this.props.placeholder || '',
        }

        if (!this.state.placeholder) {
            switch (this.state.documentType) {
                case DOC_TEMPLATE.QUOTE_TEMPLATE:
                    this.state.placeholder = this.props.intl.formatMessage(messages['template_placeholder'])
                    break
                case DOC_TEMPLATE.CONTRACT_TEMPLATE:
                    this.state.placeholder = this.props.intl.formatMessage(messages['contract_template_placeholder'])
                    break
                case DOC_TEMPLATE.ORDER_TEMPLATE:
                    this.state.placeholder = this.props.intl.formatMessage(messages['order_template_placeholder'])
                    break
                case DOC_TEMPLATE.INVOICE_TEMPLATE:
                    this.state.placeholder = this.props.intl.formatMessage(messages['invoice_template_placeholder'])
                    break
                case 'snippet':
                    this.state.placeholder = this.props.intl.formatMessage(messages['snippet_placeholder'])
                    break
                case EMAIL_TEMPLATE.TYPE_EMAIL_INVOICE:
                    this.state.placeholder = this.props.intl.formatMessage(messages['invoice_email_template_placeholder'])
                    break
                case EMAIL_TEMPLATE.TYPE_EMAIL_QUOTE:
                    this.state.placeholder = this.props.intl.formatMessage(messages['quote_email_template_placeholder'])
                    break
                case EMAIL_TEMPLATE.TYPE_EMAIL_ORDER:
                    this.state.placeholder = this.props.intl.formatMessage(messages['order_email_template_placeholder'])
                    break
                case EMAIL_TEMPLATE.TYPE_EMAIL_CONTRACT:
                    this.state.placeholder = this.props.intl.formatMessage(messages['contract_email_template_placeholder'])
                    break
            }
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            this.onChange(selectedOption ? selectedOption.value : '')
        });
    }

    loadDocuments() {
        let endpoint = `/documents/templates/${this.state.documentType}`
        if (this.props.isEmailTemplate) {
            endpoint = `/templates/mail?templateKey=${this.props.documentType}`
        }
        AppContext.getApiClient().get(endpoint).then(res => {
            this.setState({
                options: res.data.map(doc => {
                    return {
                        value: doc.id,
                        label: doc.attributes.name || this.props.intl.formatMessage(messages['default_name'])
                    }
                }),
            })
        })
    }

    componentDidMount() {
        this.loadDocuments()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOption) {
            this.setState({
                selectedOption: nextProps.value || ''
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                placeholder={this.state.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                noResultsText={this.props.intl.formatMessage(messages['no_snippet_available'])}
            />
        )
    }
}

export default injectIntl(TemplateSelector)





// WEBPACK FOOTER //
// ./src/common/template/selection.component.jsx